<template>
	<section class="page" v-loading="loadings.main">
		<el-tabs v-model="activeName">
			<el-tab-pane label="待推送" name="pending">
				<div class="content-box"  v-if="activeName=='pending'">
					<div class="operator">
						<div class="operator-col">
							<el-input
									class="el-input"
									size="mini"
									v-model="filterTableSearch"
									placeholder="品牌方编号/名称"
									suffix-icon="el-icon-search"
									clearable
							></el-input>
						</div>
						<div class="operator-col">
							<product-input :params="{allowCreate: false}" v-model="filterProducts"></product-input>
						</div>
						<div class="operator-col">
							<el-button
									size="mini"
									type="primary"
									@click="handleCreateDewu()"
									v-loading="loadings.create"
							>添加</el-button>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						:has-delete="false"
            :is-selectable="true"
						:search-filter="filterTableSearch"
            @doedit="handleEdit($event)"
						:list-url="'dewu/product_dewu/pending'"
            :batch-ops="[
                {key:'doHasPushDewu',name:'推送至得物'},
                {key:'doHasDeleteProductDewu',name:'删除'},
            ]"
            @click-batch-op="handleClickBatchOp"
					>
						<template slot="listOp" slot-scope="scope">
							<el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" @click="handlePush(scope.row._id)">推送至得物</el-button>
						</template>
					</curd-table>
				</div>
			</el-tab-pane>

			<el-tab-pane label="已推送" name="ending">
				<div class="content-box"  v-if="activeName=='ending'">
					<div class="operator">
						<div class="operator-col">
							<el-input
									class="el-input"
									size="mini"
									v-model="filterTableSearch"
									placeholder="品牌方编号/名称"
									suffix-icon="el-icon-search"
									clearable
							></el-input>
						</div>
						<div class="operator-col">
							<enum-filter
									size="mini"
									v-model="filterStatus.index"
									clearable
									data-model-name="Product_color_dewu"
									field="is_success"
							></enum-filter>
						</div>
					</div>
					<curd-table
							ref="listTable"
							:data-model="editorDataModel"
							:fields="endingTableFields"
							:has-delete="false"
							:is-selectable="true"
							:search-filter="filterTableSearch"
							:kv-filter="kvFilter"
							@doedit="handleEdit($event)"
							:list-url="'dewu/product_dewu/ending'"
							:batch-ops="[
                {key:'doHasQueryNewProductStatus',name:'绑定/更新状态'},
                {key:'doHasVerifyNewProduct',name:'审核新品'},
            ]"
							@click-batch-op="handleClickBatchOp"
					>
						<template slot="listOp" slot-scope="scope">
							<el-button type="text" size="mini" @click="handleDelete(scope.row)">删除</el-button>
							<el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
							<el-button type="text" size="mini" @click="handleRePush(scope.row)">推送</el-button>
						</template>
					</curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
    <editor
        :show.sync="editorVisible"
        data-model-name="Product_color_dewu"
        :record-id="editorProductId"
        :brand-id="brandId"
        :fields="editorFields"
        @doEditClassify="handleEditClassify($event)"
        handler-url="tool/do_category_mapping"
        @change="refreshTable('listTable')"
    ></editor>
	</section>
</template>
<style>
</style>

<script>
import {mapState} from "vuex";

import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterClassify from "@/mixins/Filter/FilterClassify.js";
import FilterProducts from "@/mixins/Filter/FilterProducts.js";
import Store from "@/basics/store";
import FilterStatus from "@/mixins/Filter/FilterStatus.js";
export default {
	mixins: [
		CurdPage,
		Filters,
		FilterClassify,
		FilterProducts,
		Store,
		FilterStatus
	],

	data() {
		return {
      loadings: {
        main: false,
        editor:false,
      },

      btnChangeEnable:false,
			editorDataModel: "Product_color_dewu",
      filterDateSlot : '',
      editorProductId: "",
      brandId:'',
			activeName: "pending",
			filterStatus: { field: "is_success", index: null },

      listOps: [
        {
          name: "edit",
          show_name: "编辑",
          handler: "doedit",
        },
      ],

			tableFields: [
				{
					name: "product_color",
				},
        {
          name: "show_id",
        },
				{
					name: "brand",
				},
        {
          name: "classify",
        },
				{
					name: "dewu_category",
				},
				{
					name: "dewu_spec",
				},
				{
					name: "fix_id",
				},
        {
          name:"is_push",
        },
        {
          name:"updated_at",
          sortable: "custom",
        },
			],
			endingTableFields: [
				{
					name: "product_color",
				},
				{
					name: "show_id",
				},
				{
					name: "brand_show_id",
				},
				{
					name: "color_code",
				},
				{
					name: "classify",
				},
				{
					name: "dewu_category",
				},
				{
					name: "dewu_spec",
				},
				{
					name: "fix_id",
				},
				{
					name:"is_push",
				},
				{
					name:"apply_id",
				},
				{
					name:"is_success",
					sortable: "custom",
				},
				{
					name:"audit_reject_reason",
				},
				{
					name:"updated_at",
					sortable: "custom",
				},
			],
      editorFields: [
        {
          name: "product_color",
          isOnlyShow: true,
          col: 12
        },
        {
          name: "brand_show_id",
          isOnlyShow: true,
          col: 12
        },
        {
          name: "color_code",
          isOnlyShow: true,
          col: 12
        },
        {
          name: "classify",
          isOnlyShow: true,
          col: 12,
          params: {
            isLastLevel: true,
          },
        },
				{
					name: "dewu_category",
					rules: ["required"],
					col: 12,
				},
				{
					name: "dewu_spec",
					rules: ["required"],
					col: 12,
					width: '100%',
				},
				{
					name: "fix_id",
					rules: ["required"],
					col: 12,
					width: '100%',
				},
				{
					name: "images",
					rules: ["required"],
					col: 12,
					width: '100%',
				}
      ],
			editorColorVisible: false,
			editorQuotaVisible: false,
			editorColorId: "",
      multipleSelection:[],
    };
	},
  computed: {
    ...mapState(["userPrivilegeMapping", "dewu_classifies"])
  },
  methods: {
    handleEditClassify(id) {
      this.editorProductId = id;
      this.editorVisible = true;
      this.loadings.editor = true;
      this.refreshClassifyData().then(json => {
        debugger;
        this.loadings.editor = false;
      }).catch(error => {
        this.loadings.editor = false;
        this.editorItemVisible = false;
        debugger;
        this.$message.warning(error.data.msg);
      })
    },
    async refreshClassifyData(){
      try {
        const json = await this.$axios.get(`/tool/do_category_mapping/${this.editorProductId}`);
        // this.items = json.data.items;
        // this.dewuItems = json.data.third_items;
        return json;
      } catch (e) {
        throw e;
      }
    },

    // cancelfilterDateSlot(){
    //   this.filterDateSlot = '';
    //   this.$delete(this.kvFilter, 'zero');
    //   this.refreshTables()
    // },

    handlePush(id) {
      this.loadings.main = true;
      this.$axios.post('/dewu/nps_apply', {
        ids: id
      })
        .then((json) => {
            this.loadings.main = false;
            if(json.data.rstno == 1){
              this.$message({
                type: "success",
                message: json.data.msg,
              });
              this.loadings.main = false;
              this.refreshTable("listTable");
              this.refreshTable("inputListTable");
            }else {
              this.$message({
                type: "error",
                message: json.data.msg,
              });
            }
          })
          .catch(json=>{
            this.$message({
                type: "error",
                message: json.data.msg,
              });
          })
    },
		handleRePush(item){
			this.editorProductId = item._id
			this.loadings.main = true;
			this.$axios.post(`/dewu/edit_new_goods/${this.editorProductId}`)
					.then((json) => {
						this.loadings.main = false;
						if(json.data.rstno == 1){
							this.$message({
								type: "success",
								message: json.data.msg,
							});
							this.loadings.main = false;
							this.refreshTable("listTable");
							this.refreshTable("inputListTable");
						}else {
							this.$message({
								type: "error",
								message: json.data.msg,
							});
						}
					})
					.catch(json=>{
						this.$message({
							type: "error",
							message: json.data.msg,
						});
					})
		},

		refreshTables() {
			this.refreshTable("listTable");
		},
    doHasPushDewu(id){
      this.payIsIncome = true;
      this.payEditorId = id;
      this.payEditorVisible = true;
      console.log(id)
    },
		handleBatch_doHasDeleteProductDewu(checks){
			this.$confirm("是否确定删除?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				this.batchConfirmInfo = {
					count: 0,
					recordIds: [],
				};
				const data = this.$refs["listTable"].tableData.filter((v, k) => {
					return checks[k];
				});
				data.forEach(v => {
					this.batchConfirmInfo.count++;
					this.batchConfirmInfo.recordIds.push(v._id);
				});
				this.$axios.post('/dewu/delete_product_dewu', {
					ids: this.batchConfirmInfo.recordIds
				})
						.then((json) => {
							console.log(json.data)
							if(json.data.rstno == 1){
								this.$message({
									type: "success",
									message: json.data.msg,
								});
								this.loadings.main = false;
								this.refreshTable("listTable");
								this.refreshTable("inputListTable");
							}else {
								this.$message({
									type: "error",
									message: json.data.msg,
								});
							}
						})
						.catch(function (error){
							console.log(error)
						})
			}).catch(() => {
				this.loadings.main = false;
				this.$message({
					type: "info",
					message: "已取消删除",
				});
			});
		},

    handleBatch_doHasPushDewu(checks) {
      this.batchConfirmInfo = {
        count: 0,
        recordIds: [],
      };

      const data = this.$refs["listTable"].tableData.filter((v, k) => {
        return checks[k];
      });
      data.forEach(v => {
        this.batchConfirmInfo.count++;
        this.batchConfirmInfo.recordIds.push(v._id);
      });
      this.$axios.post('/dewu/nps_apply', {
        ids: this.batchConfirmInfo.recordIds
      })
          .then((json) => {
            console.log(json.data)
            if(json.data.rstno == 1){
              this.$message({
                type: "success",
                message: json.data.msg,
              });
              this.loadings.main = false;
              this.refreshTable("listTable");
              this.refreshTable("inputListTable");
            }else {
              this.$message({
                type: "error",
                message: json.data.msg,
              });
            }
          })
          .catch(function (error){
            console.log(error)
          })
    },

		handleBatch_doHasVerifyNewProduct(checks) {
			this.batchConfirmInfo = {
				count: 0,
				recordIds: [],
			};

			const data = this.$refs["listTable"].tableData.filter((v, k) => {
				return checks[k];
			});
			data.forEach(v => {
				this.batchConfirmInfo.count++;
				this.batchConfirmInfo.recordIds.push(v._id);
			});

			this.$axios.post('/dewu/verify_new_goods', {
				ids: this.batchConfirmInfo.recordIds
			}).then((json) => {
						if(json.data.rstno == 1){
							this.$message({
								type: "success",
								message: json.data.msg,
							});
							this.loadings.main = false;
							this.refreshTable("listTable");
							this.refreshTable("inputListTable");
						}else {
							this.$message({
								type: "error",
								message: json.data.msg,
							});
						}
					})
					.catch(function (error){
						console.log('error',error)
					})
		},

		handleBatch_doHasQueryNewProductStatus(checks) {
			this.batchConfirmInfo = {
				count: 0,
				recordIds: [],
			};

			const data = this.$refs["listTable"].tableData.filter((v, k) => {
				return checks[k];
			});
			data.forEach(v => {
				this.batchConfirmInfo.count++;
				this.batchConfirmInfo.recordIds.push(v._id);
			});

			console.log(this.batchConfirmInfo.recordIds)

			this.$axios.post('/dewu/new_goods_list', {
				ids: this.batchConfirmInfo.recordIds
			})
					.then((json) => {
						if(json.rstno == 1){
							this.$message({
								type: "success",
								message: json.data.msg,
							});
							this.loadings.main = false;
							this.refreshTable("listTable");
							this.refreshTable("inputListTable");
						}else {
							this.$message({
								type: "error",
								message: json.data.msg,
							});
						}
					})
					.catch(function (error){
						console.log(error)
					})
		},

    handleEdit(e) {
      this.editorProductId = e._id;
      this.brandId=e.brand._id
      this.editorVisible = true;
			this.getDewuClassifies();

    },

		getDewuClassifies() {

			window.$http
					.get(`/dewuClassify/lists/${this.editorProductId}`)
					.then(json => {
						// this.dewu_classifies = json.data.datas;
						Store.state.dewu_classifies = json.data.datas;
						console.log('++++++++++++',this.dewu_classifies)
					})
					.catch(err => {
						console.error(err);
					});
		},


		handleDewuNewProduct() {
			this.loadings.main = true;
			this.$axios
					.get("dewu/new_goods_list/").then({

			// this._handleSyncDewuProduct2(0,0).then(()=>{
			// 	this.loadings.main = false;
			// 	this.$message.success('完成');

			}).catch(json => {
					this.loadings.main = false;
					this.$message.error(json.data.msg);
				});
		},

		handleDelete(item) {
			this.editorProductId = item._id
			this.loadings.main = true;
			this.$confirm("是否确定删除?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
			}).then(() => {
				this.$axios.post(`/dewu/delete_new_goods/${this.editorProductId}`)
						.then((json) => {
							this.loadings.main = false;
							console.log("直接打印",json.data)
							if(json.data.rstno == 1){
								console.log("success",json.data.data)
								this.$message({
									type: "success",
									message: "删除成功",
								});
								this.loadings.main = false;
								this.refreshTable("listTable");
								this.refreshTable("inputListTable");
							}else {
								console.log("error",json.data.msg)
								this.$message({
									type: "error",
									message: json.data.msg,
								});
							}
						})
						.catch(json=>{
							this.$message({
								type: "error",
								message: json.data.msg,
							});
						})
			}).catch(() => {
				this.loadings.main = false;

				this.$message({
					type: "info",
					message: "已取消删除",
				});
			});
		},

		handleCreateDewu(){
			if(this.kvFilter.product_colors == null){
				this.$message({
					type: "error",
					message: "请选择商品",
				});
				return;
			}
			let product_color = this.kvFilter.product_colors.v
			this.$axios.post('/dewu/create_product_color_dewu', {
				product_color: product_color
			}).then((json) => {
				if(json.data.rstno == 1){
					this.$message({
						type: "success",
						message: json.data.msg,
					});
					this.loadings.main = false;
					this.refreshTable("listTable");
					this.refreshTable("inputListTable");
				}else {
					this.$message({
						type: "error",
						message: json.data.msg,
					});
				}
			}).catch(function (error){
				console.log(error)
			})
		}
	}
}
</script>
